import { render, staticRenderFns } from "./schoolCalendar.vue?vue&type=template&id=7f383258&"
import script from "./schoolCalendar.vue?vue&type=script&lang=js&"
export * from "./schoolCalendar.vue?vue&type=script&lang=js&"
import style0 from "./schoolCalendar.vue?vue&type=style&index=0&id=7f383258&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports